import SVTAPI from './svtapi';

class Comment extends SVTAPI {
  /**
   * Initializes a new, existing comment.
   *
   * @param {number} pid The pid of the comment
   */
  constructor(pid) {
    super('/comment');
    this._pid = pid;
  }

  /**
   * POST /comment/:pid/see
   * Marks comment as seen.
   *
   * @returns {Object}      The server's response
   */
  see() {
    return super.post({ url: '/' + this._pid + '/see' });
  }

  elevate() {
    return super.post({ url: '/' + this._pid + '/elevate' });
  }

  demote() {
    return super.post({ url: '/' + this._pid + '/demote' });
  }

  delete() {
    return super.remove({ url: '/' + this._pid });
  }
}

export default Comment;
